import {
  menu_item_submenu_styles_default
} from "./chunk.ZQEOJRBW.js";
import {
  FadvMenuItemSubmenu
} from "./chunk.57CURAO4.js";
import {
  menu_item_styles_default
} from "./chunk.UYM7GGV6.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  n
} from "./chunk.D5EJUUKV.js";
import {
  $
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/menu-item/menu-item.ts
var FadvMenuItem = class extends FadvMenuItemSubmenu {
  getRole() {
    return "menuitem";
  }
  render() {
    return $`<div part="base" class=${o({
      "menu-item": true,
      "menu-item--checked": this.checked,
      "menu-item--disabled": this.disabled,
      "menu-item--has-submenu": this.hasSubmenu,
      "menu-item--submenu-expanded": this.expanded,
      "menu-item--has-prefix": this.hasSlot.test("prefix"),
      "menu-item--has-suffix": this.hasSlot.test("suffix")
    })} @click=${this.handleClick} @mouseenter=${this.handleMouseenter} @mouseleave=${this.handleMouseleave} @touchend=${this.handleTouchend} ><span part="prefix" class="menu-item__prefix"><slot name="prefix"></slot></span><span part="label" class="menu-item__label"><slot></slot></span><span part="suffix" class="menu-item__suffix"><slot name="suffix"></slot></span>${this.renderSubmenu()}</div>`;
  }
};
FadvMenuItem.styles = [menu_item_styles_default, menu_item_submenu_styles_default];
FadvMenuItem = __decorateClass([
  n("fadv-menu-item")
], FadvMenuItem);

export {
  FadvMenuItem
};
